import { assessmentTreatmentGoalsApi } from "./index";

export const manageGoalsApi = assessmentTreatmentGoalsApi.injectEndpoints({
  endpoints: (builder) => ({
    createGoalTracking: builder.mutation({
      query: ({ assessmentId, data, clientType }) => ({
        url: `/${clientType}/assesment-goal/tracking/create/${assessmentId}`,
        method: 'POST',
        data,
      }),
      extraOptions: {
        suppressErrorToast: true,
      },
      invalidatesTags: ["AssessmentStepTracking"],
      transformResponse: (response) => {
        return response.data;
      }
    }),
    updateGoalTracking: builder.mutation({
      query: ({ assessmentId, trackedId, data, clientType }) => ({
        url: `/${clientType}/assesment-goal/tracking/update/${assessmentId}/${trackedId}`,
        method: 'PUT',
        data,
      }),
      extraOptions: {
        suppressErrorToast: true,
      },
      invalidatesTags: ["AssessmentStepTracking"],
      transformResponse: (response) => {
        // console.log({response, _, args});
        // if(!response?.data?.length) {
        //   return null;
        // }
        // let assessmentGoalId = args?.data?.assesment_goal;
        // let updatedTrackingData = response?.data?.find(row => row.id === assessmentGoalId);
        // if(!updatedTrackingData) {
        //   return null;
        // }
        // return updatedTrackingData?.goalTracking;
        return response.data;
      }
      // async onQueryStarted({ args, ...patch }, { dispatch, queryFulfilled }) {
      //   console.log("draft args", args);
      //   const patchResult = dispatch(
      //     assessmentTreatmentPlanApi.util.updateQueryData('AssessmentStepTracking', args, (draft) => {
      //       console.log("draft >>>", draft)
      //       // Object.assign(draft, patch)
      //     })
      //   )
      //   try {
      //     await queryFulfilled
      //   } catch {
      //     patchResult.undo()
      //   }
      // },
    }),
    deleteGoalTracking: builder.mutation({
      query: ({ assessmentId, trackedId, clientType }) => ({
        url: `/${clientType}/assesment-goal/tracking/remove/${assessmentId}/${trackedId}`,
        method: 'DELETE',
      }),
      extraOptions: {
        suppressErrorToast: true,
      },
      invalidatesTags: ["AssessmentStepTracking"]
    }),
  }),
});

export const {
  useCreateGoalTrackingMutation,
  useUpdateGoalTrackingMutation,
  useDeleteGoalTrackingMutation,
} = manageGoalsApi;